import { Button, Divider, Form, Input, Modal, notification } from 'antd';
import { format } from 'date-fns';
import React, { useState } from 'react';
import { isSuperUser } from '../../../../../helpers/user';
import { apiForceRegisterSeller, apiForceUpdateSeller, apiForceRegisterDeltapagSeller, apiForceUpdateDeltapagSeller } from '../../../../../api/accounts';
import './Identifiers.scss';

const Identifiers = ({ data }) => {
  const [updating, setUpdating] = useState(false);
  const [registering, setRegistering] = useState(false);
  const [updatingDeltapag, setUpdatingDeltapag] = useState(false);
  const [registeringDeltapag, setRegisteringDeltapag] = useState(false);

  const handleForceUpdate = async () => {
    setUpdating(true);
    try {
      await apiForceUpdateSeller(data?.id);
      notification.success({
        message: "Atualização enfileirada",
        description: "Job de atualização do seller enfileirado.",
        placement: "topRight",
      });
    } catch (error) {
      notification.error({
        message: "Erro",
        description: error?.error || "Não foi possível enfileirar a atualização do seller.",
        placement: "topRight",
      });
    } finally {
      setUpdating(false);
    }
  };

  const handleForceRegister = async () => {
    setRegistering(true);
    try {
      await apiForceRegisterSeller(data?.id);
      notification.success({
        message: "Registro enfileirado",
        description: "Job de registro do seller enfileirado.",
        placement: "topRight",
      });
    } catch (error) {
      notification.error({
        message: "Erro",
        description: error?.error || "Não foi possível enfileirar o registro do seller.",
        placement: "topRight",
      });
    } finally {
      setRegistering(false);
    }
  };

  const confirmForceRegister = () => {
    Modal.confirm({
      title: 'Forçar novo registro na Zoop?',
      content: 'Isto cria um novo seller na Zoop e deixa o seller atual órfão (o vínculo local é redefinido). Essa ação não pode ser desfeita.',
      okText: 'Forçar registro',
      okType: 'danger',
      cancelText: 'Cancelar',
      onOk: handleForceRegister,
    });
  };

  const handleForceUpdateDeltapag = async () => {
    setUpdatingDeltapag(true);
    try {
      await apiForceUpdateDeltapagSeller(data?.id);
      notification.success({
        message: "Atualização enfileirada",
        description: "Job de atualização do seller DeltaPag enfileirado.",
        placement: "topRight",
      });
    } catch (error) {
      notification.error({
        message: "Erro",
        description: error?.error || "Não foi possível enfileirar a atualização do seller DeltaPag.",
        placement: "topRight",
      });
    } finally {
      setUpdatingDeltapag(false);
    }
  };

  const handleForceRegisterDeltapag = async () => {
    setRegisteringDeltapag(true);
    try {
      await apiForceRegisterDeltapagSeller(data?.id);
      notification.success({
        message: "Registro enfileirado",
        description: "Job de registro do seller DeltaPag enfileirado.",
        placement: "topRight",
      });
    } catch (error) {
      notification.error({
        message: "Erro",
        description: error?.error || "Não foi possível enfileirar o registro do seller DeltaPag.",
        placement: "topRight",
      });
    } finally {
      setRegisteringDeltapag(false);
    }
  };

  const confirmForceRegisterDeltapag = () => {
    Modal.confirm({
      title: 'Forçar novo registro na DeltaPag?',
      content: 'Isto cria um novo seller na DeltaPag e deixa o seller atual órfão (o vínculo local é redefinido). Essa ação não pode ser desfeita.',
      okText: 'Forçar registro',
      okType: 'danger',
      cancelText: 'Cancelar',
      onOk: handleForceRegisterDeltapag,
    });
  };

  return (
    <div className='Identifiers'>
      <p className='subtitle-page'>Identificadores</p>
      <Divider />
      <div className="container-inputs">
        <div className="left-inputs">
          <Form layout="vertical">
            <Form.Item label="Criado em">
              <Input disabled value={format(data?.created_at, "dd/MM/yyyy 'às' HH:mm:ss") || "Não informado"} readOnly />
            </Form.Item>
            <Form.Item label="Identificador unificado">
              <Input disabled value={data?.id || "Não informado"} readOnly />
            </Form.Item>
          </Form>
        </div>

        <div className="right-inputs">
          <Form layout="vertical">
            <Form.Item label="Última atualização">
              <Input disabled value={format(data?.updated_at, "dd/MM/yyyy 'às' HH:mm:ss") || "Não informado"} readOnly />
            </Form.Item>
          </Form>
        </div>
      </div>
      <Divider />
      <p className='subtitle-page'>Seção Zoop</p>
      <div className="container-inputs">
        <div className="left-inputs">
          <Form layout="vertical">
            <Form.Item label="Identificador ">
              <Input disabled value={data?.zoop_id || "Não informado"} readOnly />
            </Form.Item>
            <Form.Item label="Última atualização em">
              <Input disabled value={data?.zoop_last_updated ? format(data?.zoop_last_updated, "dd/MM/yyyy 'às' HH:mm:ss") || "Não informado" : "Não informado"} readOnly />
            </Form.Item>
          </Form>
        </div>

        <div className="right-inputs">
          <Form layout="vertical">
            <Form.Item label="Status de Integração">
              <Input disabled value={data?.zoop_acquirer_status || "Não informado"} readOnly />
            </Form.Item>
            <Form.Item label="Status Interno">
              <Input disabled value={data?.zoop_internal_status || "Não informado"} readOnly />
            </Form.Item>
          </Form>
        </div>
      </div>

      {isSuperUser() && (
        <div className="zoop-actions">
          <Button type="primary" loading={updating} onClick={handleForceUpdate}>
            Forçar atualização
          </Button>
          <Button danger loading={registering} onClick={confirmForceRegister}>
            Forçar novo registro
          </Button>
        </div>
      )}

      <Divider />
      <p className='subtitle-page'>Seção DeltaPag</p>
      <div className="container-inputs">
        <div className="left-inputs">
          <Form layout="vertical">
            <Form.Item label="Identificador ">
              <Input disabled value={data?.deltapag_id || "Não informado"} readOnly />
            </Form.Item>
            <Form.Item label="Última atualização em">
              <Input disabled value={data?.deltapag_last_updated ? format(data?.deltapag_last_updated, "dd/MM/yyyy 'às' HH:mm:ss") || "Não informado" : "Não informado"} readOnly />
            </Form.Item>
          </Form>
        </div>

        <div className="right-inputs">
          <Form layout="vertical">
            <Form.Item label="Status de Integração">
              <Input disabled value={data?.deltapag_acquirer_status || "Não informado"} readOnly />
            </Form.Item>
            <Form.Item label="Status Interno">
              <Input disabled value={data?.deltapag_internal_status || "Não informado"} readOnly />
            </Form.Item>
          </Form>
        </div>
      </div>

      {isSuperUser() && (
        <div className="deltapag-actions">
          <Button type="primary" loading={updatingDeltapag} onClick={handleForceUpdateDeltapag}>
            Forçar atualização
          </Button>
          <Button danger loading={registeringDeltapag} onClick={confirmForceRegisterDeltapag}>
            Forçar novo registro
          </Button>
        </div>
      )}
    </div>
  )
}

export default Identifiers
